const guiColors = {
    'motion-primary': 'oklab(0.66 0.25 -0.00)',
    'motion-primary-transparent': 'oklab(0.66 0.25 -0.00 / 0.75)',
    'motion-tertiary': 'oklab(0.58 0.24 -0.01)',

    'looks-secondary': 'oklab(0.66 0.25 -0.00)',
    'looks-transparent': 'oklab(0.66 0.25 -0.00 / 0.35)',
    'looks-light-transparent': 'oklab(0.66 0.25 -0.00 / 0.15)',
    'looks-secondary-dark': 'oklab(0.56 0.23 -0.01)',

    'extensions-primary': 'oklab(0.89 -0.02 0.18)',
    'extensions-tertiary': 'oklab(0.73 -0.08 -0.14)',
    'extensions-transparent': 'oklab(0.89 -0.02 0.18 / 0.35)',
    'extensions-light': 'oklab(0.85 -0.05 -0.08)',

    'drop-highlight': 'oklab(0.73 -0.08 -0.14)',

    'menu-bar-background-image':
        'linear-gradient(90deg, ' +
        'oklab(0.66 0.25 -0.00 / 0.75) 0%, ' +
        'oklab(0.89 -0.02 0.18 / 0.75) 50%, ' +
        'oklab(0.73 -0.08 -0.14 / 0.75) 100%)'
};

const blockColors = {
    checkboxActiveBackground: 'oklab(0.66 0.25 -0.00)',
    checkboxActiveBorder: 'oklab(0.73 -0.08 -0.14)'
};

export {
    guiColors,
    blockColors
};
